export const LinkedinIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2010_3479)">
        <path
          d="M18.125 0.468822H1.875C1.5063 0.46507 1.15117 0.607735 0.887529 0.865514C0.623892 1.12329 0.473283 1.47513 0.46875 1.84382V18.1594C0.474103 18.5276 0.625072 18.8786 0.88862 19.1357C1.15217 19.3928 1.50683 19.5351 1.875 19.5313H18.125C18.4937 19.5342 18.8486 19.3911 19.1121 19.1332C19.3756 18.8752 19.5263 18.5235 19.5312 18.1548V1.83913C19.5247 1.47152 19.3733 1.12136 19.1099 0.864769C18.8466 0.608173 18.4927 0.465881 18.125 0.468822Z"
          fill="#0076B2"
        />
        <path
          d="M3.29141 7.61401H6.12109V16.7187H3.29141V7.61401ZM4.70703 3.08276C5.03158 3.08276 5.34884 3.17902 5.61868 3.35937C5.88851 3.53971 6.09879 3.79603 6.22292 4.09591C6.34705 4.39579 6.37945 4.72574 6.31602 5.04403C6.25259 5.36233 6.09618 5.65466 5.86657 5.88404C5.63697 6.11342 5.3445 6.26955 5.02614 6.33268C4.70779 6.39581 4.37787 6.36309 4.07811 6.23868C3.77835 6.11426 3.52223 5.90374 3.34214 5.63373C3.16206 5.36373 3.0661 5.04638 3.06641 4.72183C3.06682 4.28698 3.23985 3.87008 3.54749 3.56274C3.85512 3.2554 4.27218 3.08276 4.70703 3.08276ZM7.89609 7.61401H10.6086V8.86401H10.6461C11.0242 8.14839 11.9461 7.3937 13.3227 7.3937C16.1883 7.38745 16.7195 9.27339 16.7195 11.7187V16.7187H13.8898V12.289C13.8898 11.2343 13.8711 9.87651 12.4195 9.87651C10.968 9.87651 10.7211 11.0265 10.7211 12.2203V16.7187H7.89609V7.61401Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2010_3479">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
